<div class="notifications-container">
  <!-- Filter row -->
  <div class="filter-row">
    <div class="filter-track" role="tablist" aria-label="{{ 'notification.filters.aria_label' | translate }}">
      <button
        type="button"
        (click)="store.setFilterType('unread')"
        [class.active]="store.selectedType() === 'unread'"
        [attr.aria-selected]="store.selectedType() === 'unread'"
        [attr.aria-label]="'activity.notifications.filter.unread' | translate"
        role="tab"
        class="filter-btn btn-compact">
        <span class="filter-btn__label">{{ 'activity.notifications.filter.unread' | translate }}</span>
        <span *ngIf="store.unreadCount() > 0" class="filter-count">{{ store.unreadCount() }}</span>
      </button>

      <button
        type="button"
        (click)="store.setFilterType('all')"
        [class.active]="store.selectedType() === 'all'"
        [attr.aria-selected]="store.selectedType() === 'all'"
        role="tab"
        class="filter-btn btn-compact">
        <span class="filter-btn__label">{{ 'activity.notifications.filter.all' | translate }}</span>
      </button>

      <button
        type="button"
        (click)="store.setFilterType('mention')"
        [class.active]="store.selectedType() === 'mention'"
        [attr.aria-selected]="store.selectedType() === 'mention'"
        nz-tooltip
        [nzTooltipTitle]="'activity.notifications.filter.mentions' | translate"
        [attr.aria-label]="'activity.notifications.filter.mentions' | translate"
        role="tab"
        class="filter-btn filter-btn--icon btn-compact">
        <i nz-icon nzType="comment"></i>
        <span *ngIf="store.mentionCount() > 0" class="filter-count">{{ store.mentionCount() }}</span>
      </button>

      <button
        type="button"
        (click)="store.setFilterType('assigned')"
        [class.active]="store.selectedType() === 'assigned'"
        [attr.aria-selected]="store.selectedType() === 'assigned'"
        nz-tooltip
        [nzTooltipTitle]="'activity.notifications.filter.assigned' | translate"
        [attr.aria-label]="'activity.notifications.filter.assigned' | translate"
        role="tab"
        class="filter-btn filter-btn--icon btn-compact">
        <i nz-icon nzType="appstore"></i>
        <span *ngIf="store.assignedCount() > 0" class="filter-count">{{ store.assignedCount() }}</span>
      </button>

      <button
        type="button"
        (click)="store.setFilterType('other')"
        [class.active]="store.selectedType() === 'other'"
        [attr.aria-selected]="store.selectedType() === 'other'"
        nz-tooltip
        [nzTooltipTitle]="'activity.notifications.filter.other' | translate"
        [attr.aria-label]="'activity.notifications.filter.other' | translate"
        role="tab"
        class="filter-btn filter-btn--icon btn-compact">
        <i nz-icon nzType="notification"></i>
        <span *ngIf="store.otherCount() > 0" class="filter-count">{{ store.otherCount() }}</span>
      </button>
    </div>
  </div>

  <app-status-message
    *ngIf="store.error()"
    class="panel-alert"
    tone="warning"
    density="compact"
    [message]="store.error() || ''"
  ></app-status-message>

  <!-- Loading state -->
  <div *ngIf="store.isLoading()" class="loading-container">
    <div class="skeleton-list" aria-hidden="true">
      <app-list-item-skeleton [showAvatar]="true" [rows]="2" titleWidth="58%"></app-list-item-skeleton>
      <app-list-item-skeleton [showAvatar]="true" [rows]="2" titleWidth="52%"></app-list-item-skeleton>
      <app-list-item-skeleton [showAvatar]="true" [rows]="2" titleWidth="64%"></app-list-item-skeleton>
    </div>
  </div>

  <!-- Empty state -->
  <div *ngIf="!store.isLoading() && store.isEmpty()" class="empty-container">
    <div class="empty-state">
      <span class="empty-state__icon" aria-hidden="true">
        <i nz-icon nzType="check-circle" nzTheme="outline"></i>
      </span>
      <p class="empty-state__title">{{ store.emptyTitleKey() | translate }}</p>
      <p class="empty-state__hint">{{ store.emptyHintKey() | translate }}</p>
    </div>
  </div>

  <!-- Notifications list -->
  <div *ngIf="!store.isLoading() && !store.isEmpty()" class="notifications-list">
    <section
      class="notifications-group"
      *ngFor="let group of store.groupedNotifications()">
      <h5 class="group-label">{{ group.labelKey | translate }}</h5>

      <app-notification-item
        *ngFor="let notification of group.items; let isLast = last; trackBy: trackByNotificationId"
        [class.is-last]="isLast"
        [notification]="notification"
        [actorIdentity]="store.getActorIdentity(notification)"
        [actorDisplayName]="store.getActorDisplayName(notification)"
        (markRead)="handleMarkRead($event)"
        (markUnread)="store.markUnread($event)"
        (navigate)="onNavigate($event)">
      </app-notification-item>
    </section>
  </div>
</div>
